/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';

import { LayoutComponent_LocalLoader as LayoutComponentLocalLoader } from 'ggApp/modules/layout';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { carouselValidation } from 'ggApp/shared/components/widgets/CampaignCarousel/utils';
import useUspCardsContent from 'ggApp/shared/hooks/useUspCardsContent';
import {
    getContentfulWidgetContent,
    extractProductWidgetData,
} from 'ggApp/shared/components/widgets/utils';

import {
    Campaign,
    FallbackMC1,
    CampaignCarouselWidget,
    Line,
    WidgetGrid,
    TileMarketingWidget,
    UspCardsWidget,
    ReviewsWidget,
    ProductWidget,
    CountdownWidget,
} from './styled';

export const ForYou = ({
    widgetList,
    countdownWidgetsList,
    className,
    productImpressionCallbacks,
    children,
    homePageContent,
    widgetListProducts,
    activeStore: { activeLanguage },
    initDone,
    isUserLoggedIn,
    getFavoritesProducts,
}) => {
    useEffect(() => {
        if (initDone && isUserLoggedIn) {
            getFavoritesProducts(undefined, false);
        }
    }, [initDone, getFavoritesProducts, isUserLoggedIn]);

    const carouselContent = (homePageContent && homePageContent.campaignBannerCarousel) || null;
    const withCarousel = carouselValidation(carouselContent) && !window.ReactNativeWebView;
    const bannerContent = (homePageContent && homePageContent.campaignBanner) || null;
    const mc2 = getContentfulWidgetContent({ homePageContent, position: 'marketingCard2' });
    const mc3 = getContentfulWidgetContent({ homePageContent, position: 'marketingCard3' });
    const uspCardsContent = useUspCardsContent(activeLanguage);
    const productWidgets = extractProductWidgetData(widgetList);
    const {
        topProducts,
        newProducts,
        category1,
        category2,
        mostPopular,
        handpicked1,
        handpicked2,
        handpicked3,
        deals,
    } = productWidgets;
    return (
        <div className={className}>
            {children}
            {withCarousel ? (
                <CampaignCarouselWidget cards={carouselContent} />
            ) : bannerContent ? (
                <Campaign campaignBannerContent={bannerContent} />
            ) : (
                <FallbackMC1 />
            )}
            <Line title={<Translator tk="DIVISION_LINE_FOR_YOU_FEED" />} />
            <LayoutComponentLocalLoader fullHeight active={!productWidgets}>
                <WidgetGrid>
                    {countdownWidgetsList?.[0] && (
                        <CountdownWidget
                            widgetData={countdownWidgetsList[0]}
                            title="COUNTDOWN_WIDGET_TITLE"
                            label="COUNTDOWN_WIDGET_CTA_TEXT"
                            url="/g-explore/black-friday"
                        />
                    )}
                    {topProducts && topProducts.products && (
                        <ProductWidget
                            widgetData={topProducts}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="topProductsWidget"
                        />
                    )}
                    {mc2 ? (
                        <TileMarketingWidget
                            headerText={mc2.title}
                            bodyText={mc2.description}
                            backgroundImage={mc2.image.url}
                            ctaLink={mc2.ctaLink}
                            ctaText={mc2.ctaText}
                        />
                    ) : (
                        <TileMarketingWidget fallback="mc2" />
                    )}
                    {newProducts && newProducts.products && (
                        <ProductWidget
                            widgetData={newProducts}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="newProductsWidget"
                        />
                    )}
                    {category1 && category1.products && (
                        <ProductWidget
                            widgetData={category1}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="categoryWidget"
                        />
                    )}
                    {category2 && category2.products && (
                        <ProductWidget
                            widgetData={category2}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                        />
                    )}
                    {uspCardsContent && (
                        <UspCardsWidget
                            title={uspCardsContent.title}
                            steps={uspCardsContent.steps}
                            cta={{ label: 'TIPS_LINKS_HIW_TEXT', url: '/how-it-works' }}
                        />
                    )}
                    <ReviewsWidget />
                    {mostPopular && mostPopular.products && (
                        <ProductWidget
                            widgetData={mostPopular}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="mostPopularProductsWidget"
                        />
                    )}
                    {handpicked1 && handpicked1.products && (
                        <ProductWidget
                            widgetData={handpicked1}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="handpickedProductWidget"
                        />
                    )}
                    {mc3 ? (
                        <TileMarketingWidget
                            headerText={mc3.title}
                            bodyText={mc3.description}
                            backgroundImage={mc3.image.url}
                            ctaLink={mc3.ctaLink}
                            ctaText={mc3.ctaText}
                        />
                    ) : (
                        <TileMarketingWidget fallback="mc3" />
                    )}
                    {handpicked2 && handpicked2.products && (
                        <ProductWidget
                            widgetData={handpicked2}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                        />
                    )}
                    {handpicked3 && handpicked3.products && (
                        <ProductWidget
                            widgetData={handpicked3}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                        />
                    )}
                    {deals && deals.products && (
                        <ProductWidget
                            widgetData={deals}
                            productImpressionCallbacks={productImpressionCallbacks}
                            widgetListProducts={widgetListProducts}
                            testId="dealsProductsWidget"
                        />
                    )}
                </WidgetGrid>
            </LayoutComponentLocalLoader>
        </div>
    );
};

export default ForYou;
